"use client";
import { useEffect, useState } from "react";
import axios from "axios";
import BlogCarousel from "../../../../../components/Blogs/BlogCarousel";
import ReactDOM from "react-dom/client";

const BlogPageClientComps = ({ article }) => {
  const addView = async () => {
    await axios.get(
      `${process.env.NEXT_PUBLIC_SERVER_API}/api/blogs/views/${article._id}`
    );
  };

  useEffect(() => {
    addView();
  }, [article]);

  useEffect(() => {
    let intervalId;

    const loadInstagramEmbedScript = () => {
      // Check if the script is already present
      if (
        !document.querySelector(
          'script[src="https://www.instagram.com/embed.js"]'
        )
      ) {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://www.instagram.com/embed.js";
        script.onload = () => {
          window.instgrm?.Embeds?.process();
          clearInterval(intervalId); // Stop polling once the script is loaded
        };
        document.body.appendChild(script);

        script.onload = () => {
          window.instgrm?.Embeds?.process();
        };
      } else {
        // Process the embeds again to ensure they are rendered
        window.instgrm?.Embeds?.process();
      }
    };

    // Poll every 3 seconds to check for the script
    intervalId = setInterval(loadInstagramEmbedScript, 2000);

    // Cleanup interval on component unmount
  }, [article]);

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const containers = document.querySelectorAll('[id="blog-bubbles"]');
    if (containers) {
      for (let container of containers) {
        if (container && mounted) {
          const root = ReactDOM.createRoot(container);
          const type = container.getAttribute("type");
          const sellerId = container.getAttribute("sellerId");
          const category = container.getAttribute("category");
          const option = container.getAttribute("option");
          const subType = container.getAttribute("subtype");
          const brand = container.getAttribute("brand");
          const style = container.getAttribute("styleselect");
          const region = container.getAttribute("region");

          root.render(
            <BlogCarousel
              type={type}
              sellerId={sellerId}
              category={category}
              option={option}
              subType={subType}
              brand={brand}
              style={style}
              region={region}
            />
          );
        }
      }
    }
  }, [mounted]);

  return <></>;
};

export default BlogPageClientComps;
